import { useTranslation } from "react-i18next";
import { BookingsFilter, BookingsList } from "../../../components";
import { useEffect, useState } from "react";
import HotelInfo from "../../../models/HotelInfo";
import StatusInfo from "../../../models/StatusInfo";
import { fetchUserList, fetchBookingList, fetchBookingData, getUserAccounts } from "../../../api/repositoryEP";
import UsersInfo, { GetUserAccountsResponseData } from "../../../models/UsersInfo";


import './BookingsPage.scss';
import BookingInfo, { BookingFilteData, SmallBookingDataList } from "../../../models/BookingInfo";
import { Drawer, notification } from "antd";
import HTMLReactParser from "html-react-parser";
import BookingDetailPage from "../BookingDetailPage/BookingDetailPage";
import BookingData from "../../../models/BookingData";
import { useLocation, useNavigate } from "react-router-dom";
import { GetFormattedUrl } from "../../../utils/urls";
import { useSessionData } from "../../../Contexts/SessionDataContext";
import { useAppConfig } from "../../../Contexts/AppConfigContext";
import { get } from "http";



const BookingsPage = (): JSX.Element => {

    const { t, i18n } = useTranslation();
    const appData = useAppConfig();

    const location = useLocation();
    const bookingId = location.state?.bookingId;

    useEffect(() => {
        if (bookingId) {
            showBookingDetail(bookingId);
        }
    }, [bookingId]);


    const [hotels, setHotels] = useState<HotelInfo[]>([]);

    const [bookingListInfo, setBookingListInfo] = useState<SmallBookingDataList>({
        elements: [],
        totalRecords: 0,
        totalComission: 0,
        totalPvp: 0
    });
    const [synchronizingId, setSynchronizingId] = useState<string>('');
    const [loadingData, setLoadingData] = useState<boolean>(false);
    const [showBookingDetailDrawer, setShowBookingDetailDrawer] = useState<boolean>(false);
    const [prevShowDrawer, setPrevShowDrawer] = useState<boolean>(false); // si pasa de true a false, recargamos 

    useEffect(() => {
        if (prevShowDrawer && !showBookingDetailDrawer) {
            // Solo se ejecuta si antes estaba abierto (true) y ahora está cerrado (false)
            onSearch(lastFilterData.numRecords, lastFilterData.page);
        }
        setPrevShowDrawer(showBookingDetailDrawer);
    }, [showBookingDetailDrawer]);



    const getHotels = (): void => {
        const hotels = appData.config.hotels;
        let hotelList: HotelInfo[] = [];
        hotels.forEach(hotel => {
            hotelList.push({ id: hotel.id, name: hotel.name });
        });
        setHotels(hotelList);
    }
    const status: StatusInfo[] = [
        { id: 0, name: "pending" },
        // { id: 1, name: "pre" },
        { id: 2, name: "active" },
        { id: 3, name: "canceled" },
        { id: 4, name: "error" },
        { id: 5, name: "pending_payment" },
        { id: 6, name: "postponed" }
    ];





    const userSessionData = useSessionData();
    const [usersFilter, setUsersFilter] = useState<GetUserAccountsResponseData[]>([]);
    const getPosibleUsersFilter = (): void => {
        if (userSessionData?.userData.role === 'super_admin' || userSessionData?.userData.role === 'wa_admin' && userSessionData.userData.idOrganization) {
            getUserAccounts(userSessionData.userData.idOrganization ?? "", userSessionData.userData.typeAccount).then(response => {
                if (response?.type == 1 && response.data) {
                    const usersData = response.data as GetUserAccountsResponseData[];
                    setUsersFilter(usersData);
                } else {
                    setUsersFilter([]);
                }
            });
        } else {
            setUsersFilter([{
                id: userSessionData?.userData.id,
                name: userSessionData?.userData.name || '',
                surname: userSessionData?.userData.surname || '',
                secondSurname: userSessionData?.userData.secondSurname || '',
            }
            ]);
        }
    }



    const [lastFilterData, setLastFilterData] = useState<BookingFilteData>({
        checkIn: null,
        checkOut: null,
        hotelId: '',
        locator: '',
        ownerName: '',
        recordDate: null,
        status: '',
        userId: '',
        numRecords: 6,
        page: 1
    });


    const getBookings = (filter: BookingFilteData): void => {
        const request = { ...filter, userId: filter.userId ?? userSessionData.userData.id };
        setLoadingData(true);
        fetchBookingList(request).then((response) => {
            if (response?.type == 1 && response.data) {
                const responseBookings = response.data as SmallBookingDataList;
                console.log(responseBookings);
                setBookingListInfo(responseBookings);


            } else {
                setBookingListInfo({
                    elements: [],
                    totalRecords: 0,
                    totalPvp: 0,
                    totalComission: 0
                });
            }
        }).finally(() => {
            setLoadingData(false);
        });
    }

const onFilter = (filter: BookingFilteData): void => {
    const newFilter = {
        ...filter,
        numRecords: lastFilterData.numRecords,
        page: 1
    };

    setLastFilterData(newFilter);
    getBookings(newFilter);
};


    const onSearch = (rows: number, page: number): void => {
        const newFilterdata = { ...lastFilterData, numRecords: rows, page };
        setLastFilterData(newFilterdata);
        getBookings(newFilterdata);
    }

    const [bookingDetail, setBookingDetail] = useState<BookingData>();
    const showBookingDetail = (bookingId: string): void => {
        fetchBookingData(bookingId, "", i18n.language).then((response) => {
            if (response && response.data) {
                setBookingDetail(response.data);
                setShowBookingDetailDrawer(true);
            }
        });
    }

    const navigate = useNavigate();
    const showCustomerVoucher = (locatorId: string): void => {
        navigate(GetFormattedUrl(`private/customer-voucher/${locatorId}`));
    }

    useEffect(() => {
        getHotels();
        getPosibleUsersFilter();
        getBookings(lastFilterData);
    }, [])


    return (
        <div className="bookings-page">
            <h2 className="title">{t('pages.bookings-page.main-title')}</h2>
            <h3 className="sub-title">{t('pages.bookings-page.subtitle')}</h3>

            <Drawer width={"100%"} open={showBookingDetailDrawer} title={bookingDetail ? HTMLReactParser(t('pages.bookings-page.booking-detail-title', [bookingDetail?.pmsLocator, bookingDetail?.hotelInfo.name])) : ''} style={{ background: "#f5f5f5" }} onClose={() => {
                setShowBookingDetailDrawer(false);
            }}>
                <BookingDetailPage bookingData={bookingDetail} setBookingData={setBookingDetail} />
            </Drawer>

            <div className="bookings-filter">
                <BookingsFilter loading={loadingData} hotelList={hotels} statusList={status} userList={usersFilter} onFilter={onFilter} />
            </div>

            <div className="bookings-list">
                <BookingsList
                    loading={loadingData}
                    totalElements={bookingListInfo.totalRecords}
                    totalsByCurrency={bookingListInfo.totalsByCurrency ?? []}
                    bookingsInfo={bookingListInfo}
                    page={lastFilterData.page}
                    pageSize={lastFilterData.numRecords}
                    search={onSearch}
                    onShowBookingDetail={showBookingDetail}
                    onShowCustomerVoucher={showCustomerVoucher}
                    synchronizingId={synchronizingId} />
            </div>
        </div>
    )
}

export default BookingsPage;